"use client";
// Imports
import { getDefaultTabHandle } from "@/lib/helpers";
import {
  Tabs as ShadTabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { List } from "@/components";
import { Fragment } from "react";

export function Tabs({ tabs, userId, showDates, defaultToAll = false }) {
  const allCount =
    tabs?.reduce((sum, tab) => sum + (tab?.data?.length || 0), 0) ?? 0;
  const defaultValue = defaultToAll
    ? "all"
    : getDefaultTabHandle(tabs);

  return (
    <ShadTabs defaultValue={defaultValue} className="mx-auto max-w-7xl">
      <TabsContainer className="shadow-inner-scroll">
        <div className="flex items-start w-full col-span-full lg:col-span-2">
          <TabsList className="p-1 overflow-x-auto ">
            {defaultToAll && (
              <TabsTrigger value="all" className="space-x-2">
                <span>All</span>
                <div className="flex items-center justify-center w-8 p-1 rounded-full aspect-square text-background bg-foreground">
                  {allCount}
                </div>
              </TabsTrigger>
            )}
            {tabs &&
              tabs.map((tab, index) => (
                <Fragment key={index}>
                  <TabsTrigger value={tab?.handle} className="space-x-2">
                    <span>{tab?.title}</span>
                    <div className="flex items-center justify-center w-8 p-1 rounded-full aspect-square text-background bg-foreground">
                      {tab?.data?.length}
                    </div>
                  </TabsTrigger>
                </Fragment>
              ))}
          </TabsList>
        </div>
      </TabsContainer>

      {defaultToAll && (
        <TabsContent value="all">
          {allCount > 0 ? (
            <div className="flex flex-col space-y-10">
              {tabs
                ?.filter((tab) => tab?.data?.length > 0)
                .map((tab, index) => (
                  <List
                    key={index}
                    showDates={showDates}
                    showAsRow={tab?.showAsRow}
                    data={tab?.data}
                    userId={userId}
                    title={tab?.title}
                    collectionHandle={tab?.handle}
                  />
                ))}
            </div>
          ) : (
            <p>Nothing saved yet.</p>
          )}
        </TabsContent>
      )}

      {tabs &&
        tabs.map((tab, index) => (
          <TabsContent key={index} value={tab?.handle}>
            {tab?.data?.length > 0 ? (
              <List
                showDates={showDates}
                showAsRow={tab?.showAsRow}
                data={tab?.data}
                userId={userId}
                title={tab?.title}
                collectionHandle={tab?.handle}
              />
            ) : (
              <p>No {tab?.title.toLowerCase()} saved.</p>
            )}
          </TabsContent>
        ))}
    </ShadTabs>
  );
}

function TabsContainer({ children, className }) {
  return (
    <div
      className={`grid w-full grid-cols-1 gap-10 lg:grid-cols-4 2xl:grid-cols-3 lg:gap-44 ${className}`}
    >
      {children}
    </div>
  );
}
